(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-card"] && !Shopify.designMode) return;
  try {
    
/*
  Multicard Swiper/Grid with transform-based fade for text
  Swiper initialized on .multicard-grid-wrapper exactly as before
*/
(function () {
  function initSection(section) {
    const wrapper = section.querySelector(".multicard-grid");
    const wrapperParent = section.querySelector(".multicard-grid-wrapper");
    if (!wrapper) return;

    const enableMobile = section.dataset.enableMobile === "true";
    const enableDesktop = section.dataset.enableDesktop === "true";
    const mediaRatio = section.dataset.mediaRatio || "square";
    const cardsMobile = Number(section.dataset.cardsMobile) || 1;
    const cardsDesktop = Number(section.dataset.cardsDesktop) || 3;

    const mediaEls = section.querySelectorAll(".multicard-media");

    function applyMediaRatio() {
      mediaEls.forEach(el => {
        el.classList.remove("media-square", "media-landscape", "media-portrait", "media-wide");
        el.classList.add("media-" + mediaRatio);
      });
    }

    function applyCardsCount(count) {
      const n = Math.min(Math.max(Math.round(count) || 1, 1), 6);
      wrapper.style.setProperty("--cards", n);
      wrapper.style.setProperty("--card-percent", (100 / n).toFixed(6) + "%");
    }

    function updateSwiperMode() {
      const isMobile = window.innerWidth < 768;
      const shouldSwiper = (isMobile && enableMobile) || (!isMobile && enableDesktop);
      const chosenCards = isMobile ? cardsMobile : cardsDesktop;

      applyCardsCount(chosenCards);

      if (shouldSwiper) {
        wrapper.classList.add("swiper-wrapper");
        wrapper.classList.remove("multicard-grid");
        wrapperParent.classList.add("multicard-swiper");

        initSwiper(chosenCards);
      } else {
        wrapper.classList.remove("swiper-wrapper");
        wrapper.classList.add("multicard-grid");
        wrapperParent.classList.remove("multicard-swiper");
      }
    }

    function initSwiper(chosenCards) {
      const swiper = new Swiper(wrapperParent, {
        slidesPerView: chosenCards,
        spaceBetween: 20
      });

      // Initialize scroll-based fade
      // initFadeWithScrollObserver(wrapperParent);
    }

    // function initFadeWithScrollObserver(wrapperParent) {
    //   const slides = wrapperParent.querySelectorAll(".multicard ");

    //   const observer = new IntersectionObserver(
    //     entries => {
    //       entries.forEach(entry => {
    //         const content = entry.target.querySelector(".multicard-info");
    //         if (!content) return;
    //         console.log(entry.intersectionRatio, content)
    //         if (entry.intersectionRatio >= 0.6) {
    //           // Fully visible: fade-in with delay
    //           setTimeout(() => {
    //             content.classList.add("fade-in");
    //             content.classList.remove("fade-out");
    //           }, 250); // 250ms delay
    //         } else {
    //           // Partially visible or leaving: fade-out immediately
    //           content.classList.remove("fade-in");
    //           content.classList.add("fade-out");
    //         }
    //       });
    //     },
    //     {
    //       root: wrapperParent,           // scroll container
    //       threshold: [0, 0.6]            // 0: leaves view, 0.6: mostly visible
    //     }
    //   );

    //   slides.forEach(slide => observer.observe(slide));
    // }


    // function updateFades(swiper) {
    //   swiper.slides.forEach((slide, i) => {
    //     const content = slide.querySelector(".multicard-info");
    //     if (!content) return;

    //     if (i === swiper.activeIndex) {
    //       content.classList.add("fade-in");
    //       content.classList.remove("fade-out");
    //     } else {
    //       content.classList.remove("fade-in");
    //       content.classList.add("fade-out");
    //     }
    //   });
    // }

    applyMediaRatio();
    updateSwiperMode();

    let resizeTimer = null;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateSwiperMode, 80);
    });

    const observer = new MutationObserver(mutations => {
      let needsUpdate = false;
      mutations.forEach(m => {
        if (m.type === "attributes" && m.attributeName.startsWith("data-")) {
          needsUpdate = true;
        }
      });
      if (needsUpdate) {
        applyMediaRatio();
        updateSwiperMode();
      }
    });

    observer.observe(section, { attributes: true });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".multicard-section").forEach(initSection);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
